import Color from '@/Enums/Color.enum';
import { ESTIMATION_CARD_BACKGROUND } from '@/constants/forecaster';
import { Paper } from '@mui/material';
import { memo } from 'react';

export const DIVIDER_TEST_ID = 'estimation-card-divider';

interface IProps {
  value: string;
  tabName: string;
  reachValue?: string;
}

const Metric = ({ label, value }: { label: string; value: string }) => (
  <div className='flex flex-1 min-w-0 flex-col items-center justify-between px-2'>
    <p className='font-medium text-xs text-center' style={{ color: Color.LightGreen3 }}>
      {label}
    </p>
    <p className='font-bold text-xl text-white'>{value}</p>
  </div>
);

const EstimationCard = memo(({ value, tabName, reachValue }: IProps) => {
  return (
    <Paper
      className='w-full flex items-stretch justify-center py-2'
      style={{
        background: ESTIMATION_CARD_BACKGROUND,
      }}
    >
      <Metric label={`Projected ${tabName} Impressions`} value={value} />
      {reachValue === undefined ? null : (
        <>
          <div data-testid={DIVIDER_TEST_ID} className='self-stretch border-l border-white/20' />
          <Metric label={`Projected ${tabName} Reach`} value={reachValue} />
        </>
      )}
    </Paper>
  );
});

export default EstimationCard;
